const CDN = "https://cdn.prod.website-files.com/602f5458a0b1d868c6c84d5b";

const items = [
  {
    title: "Low latency, high throughput",
    desc: "Easy setup in 2 lines of code with lightning-fast processing and enterprise-grade scalability.",
    image: `${CDN}/691ebeb5aa221bdf4b41b81b_Frame%202147259569.png`,
  },
  {
    title: "Highest accuracy for RAG applications",
    desc: "State-of-the-art accuracy for document understanding and retrieval augmented generation workflows.",
    image: `${CDN}/691ebeb596c94a7fdced77e7_Frame%202147259568.png`,
  },
  {
    title: "Most useful tool for document agents",
    desc: "Purpose-built for AI agents with structured outputs and seamless integration capabilities.",
    image: `${CDN}/691ebeb018dbdab56f821486_Frame%202147259562.png`,
  },
  {
    title: "Multi-Language Support",
    desc: "Process documents in 100+ languages with native OCR and understanding capabilities.",
    image: `${CDN}/692e9866db83190b26a60c8f_Multi-Language%20Support%20(3).png`,
  },
  {
    title: "All Input & Output Types",
    desc: "Support for PDF, images, Word, Excel, and more. Output to JSON, Markdown, CSV, or custom formats.",
    image: `${CDN}/692e96ca69985e159dbcfd7b_All%20Input%20%26%20Output%20Types.png`,
  },
  {
    title: "Layout Understanding",
    desc: "Automatically classify document types and intelligently split multi-document files. Streamline your document processing pipeline.",
    image: `${CDN}/692e96cc415e0dd0f8be4c50_Layout%20Understanding.png`,
  },
];

export default function ProductFeatures() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-[1200px] mx-auto px-6">
        {/* Heading */}
        <div className="text-center mb-14">
          <p className="text-[#546FFF] text-sm font-semibold tracking-widest uppercase mb-3">
            Feature-rich
          </p>
          <h2 className="text-3xl md:text-4xl font-bold text-[#080808] mb-4">
            Tailor-made for modern document pipelines
          </h2>
        </div>

        {/* 2-row × 3-column grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {items.map((item, i) => (
            <div
              key={i}
              className="bg-[#FAFAFA] rounded-2xl overflow-hidden border border-[#F0F0F0] flex flex-col"
            >
              <div className="p-6 pb-4">
                <h3 className="text-base font-bold text-[#080808] mb-2">{item.title}</h3>
                <p className="text-[#08080899] text-sm leading-relaxed">{item.desc}</p>
              </div>
              <div className="w-full mt-auto px-6 pb-6">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-auto object-contain rounded-lg"
                  loading="lazy"
                  decoding="async"
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
